import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/provider-info-screen.module.scss';
import Loader from 'src/components/Loader';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IProvider } from 'src/types/provider';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import ControlledTabs from 'src/components/common/TabsRoute';
import MainInfo from './tabs/Main';
import CaseSession from './tabs/CaseSession/List';
import CaseSessionEdit from './tabs/CaseSession/EditSeance';
import Calendar from './tabs/Calendar';
import Invoices from './tabs/Invoice/List';
import AdminWork from './tabs/AdminWork';
import Bonus from './tabs/Bonus';
import InvoicesDetail from './tabs/Invoice/Detail';
import Internal from './tabs/Internals';
import Expense from './tabs/Expenses';
import Payrolls from './tabs/Payrolls';
import PayrollsDetail from './tabs/Payrolls/Detail';

import Breadcrumbs from '../../../../../../components/Breadcrumbs';

import user from 'src/services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';
import { QueryParams } from '../../../../../../types/grid';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import Incentives from './tabs/Incentives';
import IncentiveDetail from './tabs/Incentives/Detail';

export interface StateProps {
    provider: IProvider | null;
    providersuper: Paginated<Partial<IProvider>>;
    userData: { [key: string]: any };
}
export interface DispatchProps {
    getData: (id: string | number) => void;
    getProvidersSupervisor: (params: QueryParams) => void;
}

interface RouteParams {
    id: string;
    tab: string;
    subId?: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ProviderDetail: FC<Props> = (props: Props) => {
    //const [files, setFiles] = useState([]);
    const {
        provider,
        match: {
            params: { tab, id, subId },
        },
        history,
        userData,
        providersuper,
        getProvidersSupervisor,

        getData,
    } = props;
    useEffect(() => {
        if (!provider || provider.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (
            !user.getRoles().includes(UserRole.ROLE_ADMIN) &&
            +userData.id !== +id &&
            userData?.userProviders &&
            userData?.userProviders.length
        ) {
            getProvidersSupervisor({
                filters: {
                    'supervisor.id': userData.id,
                },
                page: 1,
                itemsPerPage: 9000,
            });
        }
        // eslint-disable-next-line
    }, [userData?.userProviders]);

    useEffect(() => {
        if (!provider || provider.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, []);
    if (!provider) {
        return <Loader />;
    }
    const types: { [key: string]: boolean } = {
        'main-info': true,
        'case-sessions': true,
        calendar: true,
        invoices: true,
        payrolls: true,
        'payrolls-detail': true,
        'invoices-detail': true,
        'admin-work': true,
        internalPayment: true,
        expenses: true,
        bonuses: true,
        'received-bonuses': true,
        'received-bonuses-detail': true,
        'case-sessions-edit': true,
    };
    const tabs = [
        {
            eventKey: 'case-sessions',
            title: 'Cases & Sessions',
            isHide: false,
            renderComponent: <CaseSession caseId={subId ? `${subId}` : ''} provider={props.provider} />,
        },
        {
            eventKey: 'calendar',
            title: 'Calendar',
            isHide: false,
            renderComponent: <Calendar tab={tab} subId={subId ? `${subId}` : ''} provider={props.provider} />,
        },
        {
            eventKey: 'invoices',
            title: 'Invoices',
            isHide: false,
            renderComponent: <Invoices tab={tab} provider={props.provider} />,
        },
        {
            eventKey: 'payrolls',
            title: 'Payrolls',
            isHide: false,
            renderComponent: <Payrolls provider={props.provider} />,
        },
        {
            eventKey: 'payrolls-detail',
            title: 'Payrolls Detail',
            isHide: true,
            renderComponent: <PayrollsDetail payrollId={subId ? `${subId}` : ''} provider={props.provider} />,
        },

        {
            eventKey: 'invoices-detail',
            title: 'Invoices detail',
            isHide: true,
            renderComponent: <InvoicesDetail tab={tab} invoiceId={subId ? `${subId}` : ''} provider={props.provider} />,
        },
        {
            eventKey: 'admin-work',
            title: 'Admin Work',
            isHide: false,
            renderComponent: <AdminWork provider={props.provider} />,
        },
        {
            eventKey: 'internalPayment',
            title: 'Internal Payments',
            isHide: false,
            renderComponent: <Internal provider={props.provider} />,
        },
        {
            eventKey: 'expenses',
            title: 'Expenses',
            isHide: false,
            renderComponent: <Expense provider={props.provider} />,
        },
        {
            eventKey: 'bonuses',
            title: 'Bonus',
            isHide: false,
            renderComponent: <Bonus provider={props.provider} />,
        },
        {
            eventKey: 'received-bonuses',
            title: 'Received Bonuses',
            isHide: false,
            renderComponent: <Incentives provider={props.provider} />,
        },
        {
            eventKey: 'received-bonuses-detail',
            title: 'Received Bonus Detail',
            isHide: true,
            renderComponent: <IncentiveDetail incentiveId={subId ? `${subId}` : ''} provider={props.provider} />,
        },
        {
            eventKey: `case-sessions-edit`,
            title: 'Cases & Sessions Edit',
            isHide: true,
            renderComponent: <CaseSessionEdit tab={tab} seanceId={subId ? `${subId}` : ''} provider={props.provider} />,
        },
        {
            eventKey: 'main-info',
            title: 'Main Info',
            isHide: false,
            renderComponent: <MainInfo tab={tab} provider={props.provider} />,
        },
    ];
    if (tab && !types[`${tab}`]) {
        tabs.push({
            eventKey: `${tab}`,
            title: 'Cases & Sessions',
            isHide: true,
            renderComponent: <CaseSession seanceId={subId} caseId={tab ? `${tab}` : ''} provider={props.provider} />,
        });
    }

    const handleSelectTab = (tabPage: string | null) => {
        history.push(Router.generate(routes.PROVIDER_DETAIL, { tab: tabPage, id, subId: '' }));
    };

    if (!user.getRoles().includes(UserRole.ROLE_ADMIN) && +userData.id !== +id && providersuper.list.length) {
        let redirect = true;
        providersuper.list.forEach((prov: any) => {
            if (+prov.provider?.id === +id) {
                redirect = false;
            }
        });
        if (redirect) {
            history.push(Router.generate(routes.PROVIDERS_LIST));
        }
    }

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'PROVIDERS', path: routes.PROVIDERS_LIST },
                    { name: `${provider.fullName}`, path: '' },
                ]}
            />
            <div className={classNames(styles.detailWrap)}>
                <ControlledTabs tabs={tabs} activeTab={`${tab}`} setTab={handleSelectTab} />
            </div>
        </AdminLayout>
    );
};

export default ProviderDetail;
